export class GenerateBulkCodesDto {
  count: number;
  batch_name: string;
  expires_at?: Date;
}

export class ValidateBulkCodeDto {
  code: string;
}

export class BulkCodeUsageDto {
  code: string;
  user_id: string;
  transaction_id: string;
} 